export function successMessage(data, msgbox) {
  msgbox({
    type: 'success',
    title: '导入成功',
    message: `成功上传 ${data.successCount} 条数据`
  }).then(() => {})
}

export function errorMessage(data, createElement, msgbox) {
  msgbox({
    type: 'error',
    title: '导入失败',
    message: createElement('p', '请下载导入失败说明文件，修改或删除错误信息后再重新上传'),
    showCancelButton: true,
    cancelButtonText: '取消',
    confirmButtonText: '下载失败说明'
  }).then(() => {
    window.open(data.errFilePath)
  })
}

export const utils_transFormHandlerXlsx = source => {
  let reg = /^([A-Z])+(\d)+$/
  let sourceMap = {}
  let maxLen = 0
  Object.keys(source).forEach(key => {
    let result = key.match(reg)
    if (result) {
      let resultKey = result[0].match(/^[a-z|A-Z]+/gi)
      let index = result[0].match(/\d+$/gi)

      if (!sourceMap[resultKey]) {
        sourceMap[resultKey] = []
      }
      let val = source[key].w
      if (typeof source[key].v === 'number') {
        let val1 = source[key].v.toString()
        if (val1.length > 10) {
          val = val1
        }
      }
      if (typeof val === 'string') {
        val = val.trim()
      }
      sourceMap[resultKey][index] = val
      // sourceMap[index][result[2]] = sourceMap[index].map(item => item || '')
      // sourceMap[index].push(source[key].w)
      maxLen = Math.max(sourceMap[resultKey].length, maxLen)
    }
  })
  maxLen-- // 每一项第一个元素是 empty  所以总长度减一
  let results = []
  // console.log("sourceMap",sourceMap);

  Object.keys(sourceMap).forEach(key => {
    let item = sourceMap[key]
    // 处理列的的长度 方便后续处理
    item.shift() // 第 0 个元素是 empty
    if (item.length < maxLen) {
      while (item.length < maxLen) {
        item.push('')
      }
    }
    for (let i = 0, len = item.length; i < len; i++) {
      let val = item[i]
      if (!results[i]) {
        results[i] = []
      }
      results[i].push(val || '')
    }
  })
  return results
}

export const utils_successText = data => {
  let { duplicateCount, missRequiredCount, successCount, wrongFormatCount } = data
  let errText = ''
  if (duplicateCount || missRequiredCount || wrongFormatCount) {
    errText += `
          <li>失败数据和原因：</li>
        `
    if (duplicateCount) {
      errText += `<li>重复数据：<span class="text-red">${duplicateCount}</span>条；</li>`
    }
    if (wrongFormatCount) {
      errText += `<li>格式错误：<span class="text-red">${wrongFormatCount}</span>条；</li>`
    }
    if (missRequiredCount) {
      errText += `<li>缺少必填项：<span class="text-red">${missRequiredCount}</span>条；</li>`
    }
    errText += `<li>请检查修改后，再次上传。</li>`
  }
  let totalCount = duplicateCount + missRequiredCount + successCount + wrongFormatCount
  // let successCount =
  let text = `<ul class="sample-upload-tips">
       <li>
        共上传 <span class="text-gray-500">${totalCount}</span> 条数据，成功上传 <span class="text-green-500">${successCount}</span> 条。
      </li>
        ${errText}
    </ul>`
  return text
}

export function handleParams(file, id) {
  let fromData = new FormData()
  fromData.append('file', file)
  fromData.append('surveyId', id)
  return fromData
}

export function handleResult(res, createElement, downloadTemplate, msgbox) {
  const resData = res.data
  if (resData.code == 1) {
    msgbox({
      type: 'error',
      title: '上传失败',
      message: createElement('p', resData.errorMsg || resData.msg),
      showCancelButton: false,
    }).then(() => {
    })
  } else if (resData.code !== 2) {
    if (
      (resData.data.wrongFormatCount > 0 || resData.data.missRequiredCount > 0 || resData.data.duplicateCount > 0) &&
      resData.data.errFilePath
    ) {
      errorMessage(resData.data, createElement, msgbox)
    } else {
      successMessage(resData.data, msgbox)
    }
  } else {
    msgbox({
      type: 'error',
      title: '上传失败',
      message: createElement('p', resData.errorMsg || resData.msg),
      showCancelButton: true,
      cancelButtonText: '取消',
      confirmButtonText: '下载模板'
    }).then(() => {
      downloadTemplate()
    })
  }
}
